import Button from "hardcover-ui/components/Button";
import Icon from "hardcover-ui/components/Icon";
import faCopy from "icons/duotone/copy.svg";
import { toast } from "sonner";

export default function ReferralURL({ referralUrl }: { referralUrl: string }) {
  const copyToClipboard = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(referralUrl);
    toast.success("Copied!");
  };

  return (
    <div className="flex flex-col lg:flex-row space-y-2">
      <input
        className="py-2 lg:py-0 rounded-md bg-gray-200 border-gray-700 dark:border-gray-400 px-2 flex-1 focus:outline-hidden focus:ring-0 w-full min-w-0 border-0 sm:text-sm dark:bg-gray-700 placeholder-gray-700 dark:placeholder-gray-300 flex items-center dark:text-white whitespace-nowrap"
        defaultValue={referralUrl}
        disabled
      />
      <Button
        className="lg:ml-3 block"
        variant="primary"
        size="md"
        onClick={copyToClipboard}
      >
        <Icon icon={faCopy} size="sm" className="fill-white" />
        <span>Copy URL</span>
      </Button>
    </div>
  );
}
